import { render, staticRenderFns } from "./ChatConversationWrap.vue?vue&type=template&id=bda277d8&scoped=true&"
import script from "./ChatConversationWrap.vue?vue&type=script&lang=js&"
export * from "./ChatConversationWrap.vue?vue&type=script&lang=js&"
import style0 from "./ChatConversationWrap.vue?vue&type=style&index=0&id=bda277d8&prod&scoped=true&lang=scss&"
import style1 from "./ChatConversationWrap.vue?vue&type=style&index=1&id=bda277d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda277d8",
  null
  
)

export default component.exports